import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { EquipeResponsabilidadeService } from '../../../services/equipe-responsabilidade.service';

@Component({
  selector: 'app-equipe-responsabilidade-list',
  templateUrl: './equipe-responsabilidade-list.component.html',
  styleUrls: ['./equipe-responsabilidade-list.component.scss']
})
export class EquipeResponsabilidadeListComponent extends BaseListComponent<any> implements OnInit {

  list: any[];

  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: EquipeResponsabilidadeService,
  ) {
    super();
  }

  ngOnInit() {
    this.loading();
    this.initLoadDataTable();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.list = res;
        this.loaded();
      })
    );
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: number): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message);
      },
    });
  }
}

